import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useAuth } from '@/lib/auth';
import { Crown, ShieldAlert } from 'lucide-react';

export const Route = createFileRoute('/_app/master')({
  component: MasterLayout,
});

function MasterLayout() {
  const { isPlatform } = useAuth();

  if (!isPlatform) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60dvh] gap-3 text-center">
        <div className="surface-clay rounded-3 p-6">
          <ShieldAlert className="h-10 w-10 mx-auto" strokeWidth={1.6} />
        </div>
        <h2 className="font-display text-2xl font-bold text-fg">Acesso restrito</h2>
        <p className="text-fg-muted max-w-md">
          Esta área é exclusiva da equipe da plataforma. Se você acha que isso é um engano, fale com
          o suporte.
        </p>
      </div>
    );
  }

  return (
    <div>
      <header className="mb-6 flex items-center gap-3">
        <div className="surface-ink rounded-3 p-3">
          <Crown className="h-5 w-5 text-on-ink" strokeWidth={1.6} />
        </div>
        <div>
          <p className="text-xs font-mono uppercase tracking-wider text-fg-muted">Workspace Master</p>
          <h1 className="font-display text-2xl font-bold text-fg">Painel da plataforma</h1>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
